import { render, staticRenderFns } from "./App.vue?vue&type=template&id=367a63d9"
import script from "./App.vue.ts?vue&type=script&lang=ts&external"
export * from "./App.vue.ts?vue&type=script&lang=ts&external"
import style0 from "./App.vue?vue&type=style&index=0&id=367a63d9&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports